import { gql } from '@apollo/client';

export const SOLD_ITEMS = gql`
  query soldItemsCount {
    buyNowCreateds {
      stats {
        tokenId
        count
      }
    }
  }
`;

export const GET_BUYERS_LIST = gql`
  query buyersList($tokenId: String) {
    buyNowCreateds(where: { tokenId: $tokenId }, orderBy: blockTimestamp, orderDirection: desc) {
      buyExecutions {
        buyer
      }
    }
  }
`;

export const GET_SOLD_ITEMS_WITH_CONTACT_GALLERIES = gql`
  query soldItemsIds {
    buyNowCreateds {
      tokenId
    }
    contactGalleries {
      saleId
      tokenId
    }
  }
`;

export const GET_SOLD_ITEM_BY_TOKEN = gql`
  query confirmSoldItem($tokenId: String) {
    buyNowCreateds(where: { tokenId: $tokenId }) {
      stats {
        tokenId
        count
      }
    }
  }
`;

export const GET_CONVERSION_RATE = gql`
  query CurrencyRate {
    answerUpdateds(first: 1) {
      current
    }
  }
`;
